import { useRouteLoaderData } from 'react-router';
import type { loader as areaLayoutLoader } from '../../shell/routes/AreaLayout';

export function useAreaLayoutLoaderData() {
  const loaderData = useRouteLoaderData<typeof areaLayoutLoader>('AreaLayout');
  return loaderData;
}